import { AuroraComponentRouter } from 'app/providers/AuroraAdminProvider/components';
import React from 'react';

import { unstable } from '@broadleaf/admin-components';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

import AuroraTenantGateway from 'app/providers/AuroraAdminProvider/AuroraTenantGateway';
import { useResizeListener } from 'app/common/utils/resizer/columnResizer';

const { I18nProvider, GlobalProviders, GatewayProvider, AuthGateway } =
  unstable;

const emotionCache = createCache({
  key: 'css',
  nonce: document.querySelector('meta[name="csp-nonce"]')?.['content'] || ''
});
/**
 * The typical entrypoint component that renders the necessary providers for the application.
 *
 * If an application needs to venture from the defaults, it should import and render just the
 * providers that it needs.
 */
export const AuroraAdminProvider = ({ children, messages = {} }) => {
  useResizeListener();
  return (
    <CacheProvider value={emotionCache}>
      <I18nProvider messages={messages}>
        <InternalGatewayProvider>
          <GlobalProviders>{children}</GlobalProviders>
        </InternalGatewayProvider>
      </I18nProvider>
    </CacheProvider>
  );
};

// Overridden to include AuroraComponentRouter in place of default ComponentRouter
const InternalGatewayProvider = ({ children }) => {
  return (
    <GatewayProvider
      gatewayComponents={[
        AuroraTenantGateway,
        AuthGateway,
        AuroraComponentRouter
      ]}
    >
      {children}
    </GatewayProvider>
  );
};

export default AuroraAdminProvider;
